export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <h3 className="text-lg font-heading font-bold text-background-50 mb-4">蘑菇影视</h3>
            <p className="text-sm text-background-300 leading-relaxed">
              蘑菇影视为您提供电影、电视剧、综艺、动漫等高清免费在线观看服务，支持手机与电脑访问，播放流畅不缓冲，致力于打造优质观影体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2">
              {[
                { label: '热播榜单', href: '#ranking' },
                { label: '专题合集', href: '#index' },
                { label: '观众口碑', href: '#comments' },
                { label: '常见问答', href: '#faq' },
              ].map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">内容分类</h4>
            <ul className="space-y-2">
              {['电影', '电视剧', '综艺', '动漫'].map((cat) => (
                <li key={cat}>
                  <a href="#index" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                    {cat}在线观看
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-400">优质内容平台与技术服务商</p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700/50">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-400">
              &copy; {new Date().getFullYear()} 蘑菇影视 版权所有
            </p>
            <p className="text-xs text-background-400">
              本站内容仅供学习交流，请支持正版
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}